<template>
  <div class="notifications-list-block">
    <Notification
      :log="log"
      v-for="(log, i) in list"
      :key="log.id"
      :badgeNew="!i"
      :large="large"
      :in-modal="inModal"
      :class="{ 'large-pc': large }"
    />
  </div>
</template>

<script>
import Notification from '@/components/notifications/Notification'
// import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'

export default {
  name: 'NotificationsList',
  components: { Notification },
  props: {
    list: Array,
    large: Boolean,
    inModal: Boolean,
  },
}
</script>

<style></style>
